import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { createSelector } from 'reselect';

import { EViewMode, QueryParams, SettingsState } from './settings.types';

const getSettingsStore = (state: any): SettingsState => state.settings;

const getPrevViewMode = (state: SettingsState): EViewMode => getSettingsStore(state).prevViewMode;

const getViewByStorage = createSelector(
    getSettingsStore,
    (state, storage): EStorageType => storage,
    (state, storage, isMediaFolder: boolean): boolean => isMediaFolder,
    (store: SettingsState, storage: EStorageType, isMediaFolder: boolean) => {
        const { isGallery, isAttaches, isSharedIncoming, isTrashBin, isDocuments, isQuotaCleaner } = getStorage(storage as EStorageType);

        const isPhone = EnvironmentSelectors.isPhone();

        if ((isGallery || isMediaFolder) && !isPhone) {
            return store.viewModePhoto;
        }

        if (isGallery && isPhone) {
            return store.viewModePhotoMobile;
        }

        if (isAttaches) {
            return store.viewModeAttaches;
        }

        if (isSharedIncoming || isTrashBin) {
            return EViewMode.list;
        }

        if (isDocuments) {
            return EViewMode.thumbs;
        }

        if (isQuotaCleaner) {
            return store.viewModeQuotaCleaner;
        }

        return store.viewMode;
    }
);

const getQueryParams = createSelector(getSettingsStore, (store: SettingsState): QueryParams => store.queryParams);

export const SettingsSelectors = {
    getViewByStorage,
    getQueryParams,
    getPrevViewMode,
};
